export const handleAxiosError = (err) => {
    var _a, _b;
    const serializedError = {
        message: err.message,
        name: err.name,
        code: err.code,
    };
    if (err.response) {
        serializedError.status = err.response.status;
        serializedError.statusText = err.response.statusText;
        if (err.response.headers) {
            const entries = Object.entries(err.response.headers).map(([key, value]) => [key, String(value)]);
            serializedError.headers = Object.fromEntries(entries);
        }
        if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
            const errorData = err.response.data;
            serializedError.data = {
                errorMessage: errorData.errorMessage || errorData.message || 'Unknown error',
                amount: ((_b = errorData.errors) === null || _b === void 0 ? void 0 : _b[0].message) || '',
                error_description: errorData.error_description || errorData.description || '',
            };
        }
    }
    return serializedError;
};
